import {
    GET_ROLE_PERMISSIONS_FAIL,
    GET_ROLE_PERMISSIONS_SUCCESS,
    ADD_ROLE_PERMISSION_SUCCESS,
    ADD_ROLE_PERMISSION_FAIL,
    UPDATE_ROLE_PERMISSION_SUCCESS,
    UPDATE_ROLE_PERMISSION_FAIL,
    DELETE_ROLE_PERMISSION_SUCCESS,
    DELETE_ROLE_PERMISSION_FAIL,
   
} from "./actionTypes";

const INIT_STATE = {
    rolePermissions: [],
    error: {},
    loading: true
}

const rolePermissionReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ROLE_PERMISSIONS_SUCCESS:
            return {
                ...state,
                rolePermissions: action.payload,
                loading: false
            };

        case GET_ROLE_PERMISSIONS_FAIL:
            return {
                ...state,
                error: action.payload,
                 loading: false
            };

        case ADD_ROLE_PERMISSION_SUCCESS:
            return {
                ...state,
                rolePermissions: [action.payload, ...state.rolePermissions],
            };

        case ADD_ROLE_PERMISSION_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case UPDATE_ROLE_PERMISSION_SUCCESS:
            return {
                ...state,
                rolePermissions: state.rolePermissions.map(rolePermission =>
                    rolePermission.uid.toString() === action.payload.uid.toString()
                        ? { rolePermission, ...action.payload }
                        : rolePermission
                ),
            };

        case UPDATE_ROLE_PERMISSION_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case DELETE_ROLE_PERMISSION_SUCCESS:
            return {
                ...state,
                rolePermissions: state.rolePermissions.filter(
                    rolePermission => rolePermission.id.toString() !== action.payload.toString()
                ),
            };

        case DELETE_ROLE_PERMISSION_FAIL:
            return {
                ...state,
                error: action.payload,
            };
       
        default:
            return state
    }
}

export default rolePermissionReducer;